import { createRoute } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { CalendarView } from '@/components/calendar/calendar-view'

export const calendarIndexRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/calendar/',
  component: MeetingsPage,
})

function MeetingsPage() {
  const { projectId } = calendarIndexRoute.useParams()
  return (
    <div className="flex-1 overflow-hidden">
      <CalendarView projectId={projectId} />
    </div>
  )
}
